import React from 'react';
import { Controller, useWatch } from 'react-hook-form';
import { translate } from '@utils/i18n';
import WizardView from '@components/WizardView';
import OfficeSelector from '../OfficeSelector';
const namespace = 'features.settings.service_trade';
export default function PreviewStep({ control, preview, onNext, onBack, isLoading, error }) {
    const selectedOfficeIds = useWatch({
        control,
        name: 'selectedOfficeIds',
        defaultValue: []
    });
    const actions = [
        {
            label: translate('back', { namespace: 'generic' }),
            onClick: onBack,
            variant: 'secondary',
            disabled: isLoading
        },
        {
            label: translate('wizard.connect', { namespace }),
            onClick: onNext,
            variant: 'primary',
            disabled: selectedOfficeIds.length === 0 || isLoading,
            isLoading
        }
    ];
    return (React.createElement(WizardView, { title: translate('wizard.preview_title', { namespace }), description: translate('wizard.preview_description', { namespace }), actions: actions, error: error },
        React.createElement("div", { className: "connection-preview" },
            React.createElement("div", { className: "preview-item" },
                React.createElement("label", null, translate('wizard.company_name', { namespace })),
                React.createElement("strong", null, preview.company_name)),
            preview.account_name && (React.createElement("div", { className: "preview-item" },
                React.createElement("label", null, translate('wizard.account_name', { namespace })),
                React.createElement("strong", null, preview.account_name))),
            React.createElement("div", { className: "preview-item" },
                React.createElement("label", null, translate('wizard.vendor_id', { namespace })),
                React.createElement("strong", null, preview.vendor_id))),
        React.createElement("div", { className: "office-selection-section" },
            React.createElement("h3", null, translate('wizard.select_offices', { namespace })),
            React.createElement("p", { className: "help-text" }, translate('wizard.office_help', { namespace })),
            React.createElement(Controller, { name: "selectedOfficeIds", control: control, rules: {
                    validate: (value) => value.length > 0 || translate('wizard.office_required', { namespace })
                }, render: ({ field }) => (React.createElement(OfficeSelector, { offices: preview.offices, selectedOfficeIds: field.value, onChange: field.onChange })) }))));
}
